import { Component } from '@angular/core';
import { AppInfoService } from '../../../shared/services/general';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent {

  constructor(public appInfo: AppInfoService) { }


}
